import { PageEventProps } from '@easeltv/analytics';
import {
    Alignment,
    HorizontalPadding,
    Link,
    LinkType,
    TopPadding,
} from '@easeltv/client-sdk';

import LinkAtom from '../../Atoms/LinkAtom';
import { getLinkHref } from '../../Atoms/LinkAtom/LinkAtom.helpers';
import {
    StyledFooterLinksBlock,
    StyledFooterList,
} from './FooterLinksBlock.styled';

/* ---------------------------------- Types --------------------------------- */

/** @interface `DumbFooterLinksBlockI`
 * #### Interface for the DumbFooterLinksBlock's props object
 */
export interface DumbFooterLinksBlockI {
    /** the array of links to be displayed */
    links: Link[];

    /** controls alignment links and links container inside the footer */
    alignment: Alignment;

    /** controls left and right spacing beside the list of links */
    horizontalPadding: HorizontalPadding;

    /** controls amount of space above the list of links */
    topPadding: TopPadding;

    /** An object containing current page data, useful for tracking */
    pageObject?: PageEventProps;
}

/* -------------------------------- Component ------------------------------- */

/**
 * DumbFooterLinksBlock
 *
 * @param props DumbFooterLinksBlockI
 * @returns JSX.Element
 */
const DumbFooterLinksBlock = ({
    links,
    alignment,
    horizontalPadding,
    topPadding,
    pageObject,
}: DumbFooterLinksBlockI) => {
    const adjustedHorizontalPadding =
        alignment === Alignment.Center
            ? HorizontalPadding.None
            : horizontalPadding;

    const footerLinkCallback = (link: Link) => {
        if (pageObject) {
            window.analytics.trigger({
                type: 'footer.link.clicked',
                currentPage: pageObject,
                internal: link.type === LinkType.Internal,
                destinationUrl: getLinkHref(link),
            });
        }
    };

    return (
        <StyledFooterLinksBlock
            alignment={alignment}
            topPadding={topPadding}
            horizontalPadding={adjustedHorizontalPadding}
        >
            <StyledFooterList>
                {links.map((link) => (
                    <li key={link.id}>
                        <LinkAtom
                            data={link}
                            section="footer"
                            callback={() => footerLinkCallback(link)}
                        />
                    </li>
                ))}
            </StyledFooterList>
        </StyledFooterLinksBlock>
    );
};

/* --------------------------------- Export --------------------------------- */

export default DumbFooterLinksBlock;
